import React, {useMemo} from "react";
import {css} from "@emotion/react";

import {ComparisonTable, IUseComparisonTableReturnType} from "@pg-rp/comparison-table";

import {useMyOffersFavourites} from "../../../my_offers/hooks/use_my_offers_favourites";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {isPropertyArchived} from "../../../property/utils/is_property_archived";
import {useComparisonToolContext} from "../../contexts/comparison_tool_context";
import {TableCellHeader} from "./TableCellHeader";

export const ComparisonToolTable = (props: IUseComparisonTableReturnType<IPropertyDetail>["tableProps"]) => {
    const {favouriteProperties} = useMyOffersFavourites();
    const {isPrinting} = useComparisonToolContext();
    const showRemoveFromComparisonButton = favouriteProperties.length > 2 && !isPrinting;

    const disabledItemIds = useMemo(() => {
        return favouriteProperties.filter((property) => isPropertyArchived(property)).map((property) => property.id);
    }, [favouriteProperties]);

    return (
        <ComparisonTable<IPropertyDetail>
            {...props}
            cellHeader={({item, index}) => {
                return <TableCellHeader property={item} tableItemIndex={index} showRemoveButton={showRemoveFromComparisonButton} />;
            }}
            hideNavigationOnMobile
            headerStyle={headerStyle}
            data={favouriteProperties}
            disabledItemIds={disabledItemIds}
            gap={2}
        />
    );
};

const headerStyle = css`
    background: #fff;
`;
import React, {useMemo} from "react";
import {css} from "@emotion/react";

import {ComparisonTable, IUseComparisonTableReturnType} from "@pg-rp/comparison-table";

import {useMyOffersFavourites} from "../../../my_offers/hooks/use_my_offers_favourites";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {isPropertyArchived} from "../../../property/utils/is_property_archived";
import {useComparisonToolContext} from "../../contexts/comparison_tool_context";
import {TableCellHeader} from "./TableCellHeader";

export const ComparisonToolTable = (props: IUseComparisonTableReturnType<IPropertyDetail>["tableProps"]) => {
    const {favouriteProperties} = useMyOffersFavourites();
    const {isPrinting} = useComparisonToolContext();
    const showRemoveFromComparisonButton = favouriteProperties.length > 2 && !isPrinting;

    const disabledItemIds = useMemo(() => {
        return favouriteProperties.filter((property) => isPropertyArchived(property)).map((property) => property.id);
    }, [favouriteProperties]);

    return (
        <ComparisonTable<IPropertyDetail>
            {...props}
            cellHeader={({item, index}) => {
                return <TableCellHeader property={item} tableItemIndex={index} showRemoveButton={showRemoveFromComparisonButton} />;
            }}
            hideNavigationOnMobile
            headerStyle={headerStyle}
            data={favouriteProperties}
            disabledItemIds={disabledItemIds}
            gap={2}
        />
    );
};

const headerStyle = css`
    background: #fff;
`;
